(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/prolong-storage/assets/javascripts/prolong-storage.js') >= 0) return;  svs.modules.push('/components/tur/prolong-storage/assets/javascripts/prolong-storage.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const logger = new svs.core.log.Logger('tur:prolong-storage');
const productMapping = svs.numbergames.productMapping;
const TWENTY_SECONDS_IN_MS = 20000;
const SEVEN_DAYS_IN_SECONDS = 7 * 24 * 60 * 60;
const SEVEN_DAYS_IN_MS = SEVEN_DAYS_IN_SECONDS * 1000;
const keyMap = {
  eurojackpot: 'eurojackpotProlong',
  lotto: 'lottoProlong',
  keno: 'kenoProlong',
  vikinglotto: 'vikinglottoProlong',
  lyckoplatsen: 'lyckoplatsenProlong'
};
const cachedProlongData = {};
const inFlightProlongData = {};
const restartCachedDataTimeout = key => {
  var _cachedProlongData$ke;
  if ((_cachedProlongData$ke = cachedProlongData[key]) !== null && _cachedProlongData$ke !== void 0 && _cachedProlongData$ke.timeoutId) {
    clearTimeout(cachedProlongData[key].timeoutId);
  }
  if (!cachedProlongData[key]) {
    cachedProlongData[key] = {};
  }
  cachedProlongData[key].timeoutId = setTimeout(() => {
    delete cachedProlongData[key];
  }, TWENTY_SECONDS_IN_MS);
};
const setCachedData = (key, data) => {
  cachedProlongData[key] = {
    data
  };
  restartCachedDataTimeout(key);
};
const getObjectStoreData = async _ref => {
  let {
    key
  } = _ref;
  try {
    const objectStoreResponse = await svs.core.jupiter.callAsync({
      method: 'GET',
      path: '/player/1/objectstore',
      data: {
        keys: key
      }
    });
    return objectStoreResponse;
  } catch (error) {
    logger.error('Error getting from object store', error);
    return null;
  }
};
const postToObjectStore = async _ref2 => {
  let {
    key,
    value,
    expires
  } = _ref2;
  try {
    await svs.core.jupiter.callAsync({
      method: 'POST',
      path: '/player/1/objectstore',
      data: {
        key,
        value,
        expires
      }
    });
    logger.debug('Successfully posted to object store', {
      key,
      value,
      expires
    });
  } catch (error) {
    logger.error('Error posting to object store', error);
  }
};
const retrieveProlongData = async _ref3 => {
  var _productMapping$getPr, _cachedProlongData$ke2;
  let {
    wagerId,
    productId
  } = _ref3;
  const emptyResult = {
    filteredProlongData: null,
    key: null
  };
  if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    logger.info('User is not logged in, cannot access prolong-storage');
    return emptyResult;
  }
  if (wagerId && !Number.isInteger(Number(wagerId))) {
    logger.error('wagerId must be a number', {
      wagerId
    });
    return emptyResult;
  }
  const keyId = ((_productMapping$getPr = productMapping.getProductName(productId)) === null || _productMapping$getPr === void 0 ? void 0 : _productMapping$getPr.toLowerCase()) || productId.toLowerCase();
  if (!keyMap[keyId]) {
    logger.error("".concat(keyId, " was not found in keyMap"));
    return emptyResult;
  }
  const key = keyMap[keyId];
  if ((_cachedProlongData$ke2 = cachedProlongData[key]) !== null && _cachedProlongData$ke2 !== void 0 && _cachedProlongData$ke2.data) {
    return {
      filteredProlongData: cachedProlongData[key].data,
      key
    };
  }
  if (inFlightProlongData[key]) {
    return inFlightProlongData[key];
  }
  const prolongDataPromise = (async _objectStoreData$resp => {
    const objectStoreData = await getObjectStoreData({
      key
    });
    if (!objectStoreData) {
      logger.error('Failed to retrieve object store data');
      return {
        filteredProlongData: {},
        key
      };
    }
    const items = (_objectStoreData$resp = objectStoreData.response) === null || _objectStoreData$resp === void 0 ? void 0 : _objectStoreData$resp.items;
    let dataInObject = {};
    try {
      dataInObject = items !== null && items !== void 0 && items.length ? JSON.parse(items[0].value) : {};
    } catch (error) {
      logger.error('Failed to parse object store data', error);
      return {
        filteredProlongData: {},
        key
      };
    }
    const sevenDaysAgo = new Date(Date.now() - SEVEN_DAYS_IN_MS);
    const filteredProlongData = {};
    for (const [wagerId, timestamp] of Object.entries(dataInObject)) {
      const wagerDate = new Date(timestamp);
      if (!isNaN(wagerDate.getTime()) && wagerDate >= sevenDaysAgo) {
        filteredProlongData[wagerId] = timestamp;
      }
    }
    setCachedData(key, filteredProlongData);
    logger.debug('Retrieved prolong data from object store', {
      key,
      filteredProlongData
    });
    return {
      filteredProlongData,
      key
    };
  })();
  inFlightProlongData[key] = prolongDataPromise;
  try {
    return await prolongDataPromise;
  } finally {
    delete inFlightProlongData[key];
  }
};
const set = async _ref4 => {
  let {
    wagerId,
    productId,
    timestamp = new Date().toISOString()
  } = _ref4;
  const {
    filteredProlongData,
    key
  } = await retrieveProlongData({
    wagerId,
    productId
  });
  if (!filteredProlongData || !key) {
    logger.error('Could not set prolong data due to missing prolong data or key');
    return;
  }
  const newProlongData = _objectSpread(_objectSpread({}, filteredProlongData), {}, {
    [wagerId]: timestamp
  });
  setCachedData(key, newProlongData);
  const stringifyProlongData = JSON.stringify(newProlongData);
  await postToObjectStore({
    key,
    value: stringifyProlongData,
    expires: SEVEN_DAYS_IN_SECONDS
  });
};
const get = async _ref5 => {
  let {
    wagerId,
    productId
  } = _ref5;
  const {
    filteredProlongData
  } = await retrieveProlongData({
    wagerId,
    productId
  });
  if (filteredProlongData !== null && filteredProlongData !== void 0 && filteredProlongData[wagerId]) {
    return {
      timestamp: filteredProlongData[wagerId]
    };
  }
  return {
    timestamp: null
  };
};
setGlobal('svs.tur.prolongStorage', {
  set,
  get
});

 })(window);